import React, { useEffect } from 'react';
import styles from './O_CapsulePost.module.css';
import { useTree } from '../../../contexts/TreeContext';
// import { useNavigate } from 'react-router-dom';
// import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
// import A_Button from '@/components/A_Atoms/A_Button/A_Button';
// import { PATHS } from '@/constants/paths';
import W_CapsulePostAuthorDate from '@/components/W_Wrappers/W_CapsulePostAuthorDate/W_CapsulePostAuthorDate';
import W_CapsulePostContent from '@/components/W_Wrappers/W_CapsulePostContent/W_CapsulePostContent';
// import W_ProgressBilling from '@/components/W_Wrappers/W_ProgressBilling/W_ProgressBilling';
// import M_ParkLink from '@/components/M_Molecules/M_ParkLink/M_ParkLink';
import { MockPost } from '@/mocks';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface O_CapsulePostProps {
  capsule: MockPost;
  maxWidth?: number | string;
  showActionsMenu?: boolean;
  onDelete?: () => void;
  capsuleId?: string;
}

export default function O_CapsulePost({
  capsule,
  maxWidth = 612,
  showActionsMenu,
  onDelete,
  capsuleId,
}: O_CapsulePostProps) {
  const { getTreeById, setCurrentTree } = useTree();
  // const navigate = useNavigate();
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  // const hasTree = Boolean(capsule.treeId);

  useEffect(() => {
    const treeId = capsule.treeId;
    if (treeId) {
      const tree = getTreeById(treeId);
      if (tree) {
        setCurrentTree(tree);
        return;
      }
    }
    setCurrentTree(null);
  }, [capsule.treeId, getTreeById, setCurrentTree]);

  // const handleDonateClick = () => {
  //   const treeId = capsule.treeId;
  //   if (treeId && capsule.id) {
  //     navigate(PATHS.CAPSULE_DONATION_FUNC(capsule.id, treeId));
  //   }
  // };

  // const handlePlantTreeClick = () => {
  //   const treeId = capsule.treeId;
  //   if (treeId) {
  //     navigate(`${PATHS.TREE_BY_ID_FUNC(treeId)}?capsuleId=${capsule.id}`, {
  //       state: { capsuleId: capsule.id },
  //     });
  //     return;
  //   }
  //   navigate(PATHS.TREE);
  // };

  const authorDate = capsule.capsulePostAuthorDate;
  const content = capsule.capsulePostContent;
  // const progress = capsule.capsulePostProgress;

  const fallbackAuthorDate = authorDate || {
    avatars: capsule.avatars || [],
    coauthors: capsule.coauthors || 0,
    date: capsule.createdAt || t('capsulePost.dateNotSpecified'),
    isMyCapsule: capsule.isMyCapsule || false,
    ownerName: capsule.ownerName || t('capsulePost.unknownAuthor'),
    ownerId: capsule.ownerId,
  };

  const fallbackContent = content || {
    title: capsule.title || t('capsulePost.titleUnavailable'),
    text: capsule.content || t('capsulePost.contentUnavailable'),
    commentCount: capsule.comments || 0,
    plantCount: capsule.likes || 0,
    indicator: 'comment' as const,
  };

  return (
    <div className={styles.wrapper} style={{ maxWidth }}>
      <div className={styles.top_content_wrapper}>
        <W_CapsulePostAuthorDate
          avatars={fallbackAuthorDate.avatars}
          coauthors={fallbackAuthorDate.coauthors}
          date={fallbackAuthorDate.date}
          isMyCapsule={fallbackAuthorDate.isMyCapsule}
          ownerName={fallbackAuthorDate.ownerName}
          ownerId={fallbackAuthorDate.ownerId}
          showActionsMenu={showActionsMenu}
          onDelete={onDelete}
          capsuleId={capsuleId}
        />
        <W_CapsulePostContent
          title={fallbackContent.title}
          text={fallbackContent.text}
          commentCount={fallbackContent.commentCount}
          plantCount={fallbackContent.plantCount}
          indicator={fallbackContent.indicator}
        />
      </div>
      {/* {hasTree && progress ? (
        <div className={styles.tree_wrapper}>
          <div className={styles.tree_content_wrapper}>
            <W_ProgressBilling
              progress={progress.progress}
              totalDonations={progress.totalDonations}
              cost={progress.cost}
              name={progress.name}
              donorsCount={progress.donorsCount}
              showDonorsCount={progress.showDonorsCount}
              donorsAvatars={progress.donorsAvatars}
            />
            <M_ParkLink link={progress.link} name={progress.name} />
          </div>
          <A_Button
            onClick={handleDonateClick}
            className={styles.donate_button}
            showIcon={true}
            icon={<Q_Icon.PlantIcon width={24} height={24} fill='none' />}
          >
            {t('capsulePost.donate')}
          </A_Button>
        </div>
      ) : (
        <div className={styles.no_tree_section}>
          <A_Button
            onClick={handlePlantTreeClick}
            className={styles.plant_button}
            showIcon={true}
            icon={<Q_Icon.PlantIcon width={24} height={24} fill='none' />}
          >
            {t('capsulePost.plantTree')}
          </A_Button>
        </div>
      )} */}
    </div>
  );
}
